import { mapGetters } from 'vuex'
import store from '../store/index.js'
export default{
  computed:{
     ...mapGetters(['menusList'])

  },
  mounted(){
  },
 created(){
 	},
  methods:{
    dtrouter(){
    let routers =[
      { path:'/homeList',
        component:require('@/view/Rights/homeList').default?require('@/view/Rights/homeList').default:require('@/view/Rights/homeList')
      },
      { path:'/homeCateList',
        component:require('@/view/Rights/homeCateList').default?require('@/view/Rights/homeCateList').default:require('@/view/Rights/homeCateList')
      },
      { path:'/userList',
        component:require('@/view/Rights/userList').default?require('@/view/Rights/userList').default:require('@/view/Rights/userList')
      },
      { path:'/roleList',
        component:require('@/view/Rights/roleList').default?require('@/view/Rights/roleList').default:require('@/view/Rights/roleList')
      },
      { path:'/menuList',
        component:require('@/view/Rights/menuList').default?require('@/view/Rights/menuList').default:require('@/view/Rights/menuList')
      },
      { path:'/communityList',
        component:require('@/view/Rights/communityList').default?require('@/view/Rights/communityList').default:require('@/view/Rights/communityList')
      },

     ]
     let menus= this.menusList
      console.log(menus)
     routers = routers.filter(item=>{
     	return menus.some(val=>val.indexPath==item.path)
     })
     let resRoute = [{
     	path:'/',
     	redirect:'/home',
     	component:require('@/view/Index').default?require('@/view/Index').default:require('@/view/Index'),
     	children:
       [
         { path:'/home',
           component:require('@/view/Home/home').default?require('@/view/Home/home').default:require('@/view/Home/home')
         },
     		...routers
     	]
     }]
     //用以下的语法this.$router.addRoutes(resRoute)会报错，只能for方法
    // this.$router.addRoutes(resRoute)
     for (let i of resRoute) {
          this.$router.addRoute(i)
      }
    }

  }

}
